import { render, staticRenderFns } from "./tooltip.vue?vue&type=template&id=1f9e4de2&scoped=true"
import script from "./tooltip.vue?vue&type=script&lang=ts"
export * from "./tooltip.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f9e4de2",
  null
  
)

export default component.exports